import { Grid, Group, NumberInput, Slider, Text } from '@mantine/core';

import SectionTitle from 'components/SectionTitle';
import { MAX_DESIRED_LOAN, MAX_DESIRED_RATE, MIN_DESIRED_LOAN, MIN_DESIRED_RATE } from 'constants/App';
import { roundToNearest10, roundToNearest1000 } from 'utils/App';
import { IPageData } from '.';

const DesiredLoan = ({ form, isMobile, t }: IPageData) => {
  return (
    <>
      <SectionTitle title={t('section.desired.loan')} />
      <Grid columns={isMobile ? 1 : 12}>
        <Grid.Col span={isMobile ? 1 : 6}>
          <Group justify={isMobile ? 'flex-start' : 'space-between'}>
            <Text size={'sm'} c={'#323343'}>{t('input.desired.loan.label')}</Text>
            <NumberInput
              rightSection={<Text size={'sm'} >{t('currency.CHF')}</Text>}
              rightSectionWidth={40}
              w={isMobile ? '100%' : '50%'}
              min={MIN_DESIRED_LOAN}
              max={MAX_DESIRED_LOAN}
              allowDecimal={false}
              key={form.key('desiredLoan')}
              {...form.getInputProps('desiredLoan')}
              onBlur={(event) =>
                form.setFieldValue(
                  'desiredLoan',
                  roundToNearest1000(Number(event.target.value))
                )
              }
            />
          </Group>
          <Slider
            min={MIN_DESIRED_LOAN}
            max={MAX_DESIRED_LOAN}
            step={1000}
            mt={10}
            label={null}
            color={'#378F0E'}
            styles={{ thumb: { backgroundColor: '#62AF45', border: 'none' } }}
            key={form.key('desiredLoan')}
            {...form.getInputProps('desiredLoan')}
          />
        </Grid.Col>
        <Grid.Col span={isMobile ? 1 : 6}>
          <Group justify={isMobile ? 'flex-start' : 'space-between'}>
            <Text size={'sm'} c={'#323343'}>{t('input.desired.rate.label')}</Text>
            <NumberInput
              rightSection={<Text size={'sm'} >{t('currency.CHF')}</Text>}
              rightSectionWidth={40}
              w={isMobile ? '100%' : '50%'}
              min={MIN_DESIRED_RATE}
              max={MAX_DESIRED_RATE}
              allowDecimal={false}
              key={form.key('desiredRate')}
              {...form.getInputProps('desiredRate')}
              onBlur={(event) =>
                form.setFieldValue(
                  'desiredRate',
                  roundToNearest10(Number(event.target.value))
                )
              }
            />
          </Group>
          <Slider
            min={MIN_DESIRED_RATE}
            max={MAX_DESIRED_RATE}
            step={10}
            mt={10}
            label={null}
            color={'#378F0E'}
            styles={{ thumb: { backgroundColor: '#62AF45', border: 'none' } }}
            key={form.key('desiredRate')}
            {...form.getInputProps('desiredRate')}
          />
        </Grid.Col>
      </Grid>
    </>
  )
}

export default DesiredLoan;